import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createAdjustment: [],
  loading: false,
  error: null,
};

const createAdjustmentSlice = createSlice({
  name: "createAdjustment",
  initialState,
  reducers: {
    fetchCreateAdjustmentRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreateAdjustmentSuccess: (state, action) => {
      state.loading = false;
      state.createAdjustment = action.payload;
    },

    fetchCreateAdjustmentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreateAdjustmentRequest,
  fetchCreateAdjustmentSuccess,
  fetchCreateAdjustmentFailure,
} = createAdjustmentSlice.actions;

export default createAdjustmentSlice.reducer;